import React from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import AllPatientList from './Patients/AllPatientList'
import MedCenterList from './CounterAgents/MedCenterList'
import MedCenterOrgList from './CounterAgents/MedCenterOrgList'
import OrgHistory from './CounterAgents/OrgHistory'
import OrgPatientList from './CounterAgents/OrgPatientList'
import AllOrgList from './CounterAgents/allOrg/AllOrgList'
import Calendar from './Calendar/Calendar'
import OrgCalendar from './CounterAgents/OrgCalendar'
import OrganizationList from './CounterAgents/allOrg/OrganizationList'
import OrganizationPatientList from './CounterAgents/allOrg/OrganizationPatientList'
import OrganiztionsList from './CounterAgents/AllOrgList'
import AllCabinetSurveysHistory from './Calendar/CabinetSurveysHistory/AllCabinetSurveysHistory'
import OrganizationCabinetSurveyHistory from './Calendar/CabinetSurveysHistory/OrganizationCabinetSurveyHistory'
import OrganizationCarSurveysHistory from './Calendar/CarSurveyHistory/OrganizationCarSurveysHistory'
import AllCarSurveysHistory from './Calendar/CarSurveyHistory/AllCarSurveysHistory'
import AllCarSurveysHistoryToday from "./Calendar/CarSurveyHistory/AllCarSurveysHistoryToday";
import Roles from './Activities/Roles'
import {PatientQrResultSwitcher} from '../General/QrResult/QrResult'
import OrgSearch from "../General/OrgSearch";
import {PatientQrResultSwitcher2} from "../General/QrResult2/QrResult2";
import NotificationsVerificationCenter from "./Notifications/Notifications.verificationCenter";
import {PageAnalyticDoctor} from "./Activities/Analytic.doctor";
import {PageAnalyticPlaces} from "./Activities/Analytic.places";
import DiagnosesMismatch from "./Doctor/DiagnosesMismatch";
import Doctors from "./Doctor/Doctors";

function VerificationCenterRoutes() {
    const {REACT_APP_URL_PREFIX} = process.env

    return (
        <Switch>
            <Route path={REACT_APP_URL_PREFIX + '/orgSearch'} exact> <OrgSearch/></Route>

            <Route path={REACT_APP_URL_PREFIX + '/patients/allPatientList'} exact>
                <AllPatientList/>
            </Route>

            <Route path={REACT_APP_URL_PREFIX + '/counterAgents/MedCenterList'} exact>
                <MedCenterList/>
            </Route>

            <Route path={REACT_APP_URL_PREFIX + '/counterAgents/OrganizationList'} exact>
                <OrganiztionsList/>
            </Route>


            <Route path={REACT_APP_URL_PREFIX + '/counterAgents/MedCenterOrgList/:medId/:orgName'} exact>
                <MedCenterOrgList/>
            </Route>

            <Route
                path={REACT_APP_URL_PREFIX + '/counterAgents/MedCenterOrgList/:medId/:orgName/organizations/:orgId/:history'}>
                <OrgHistory/>
            </Route>

            <Route path={REACT_APP_URL_PREFIX + '/calendar'} exact>
                <Calendar/>
            </Route>
            <Route path={REACT_APP_URL_PREFIX + '/notifications'} exact>
                <NotificationsVerificationCenter/>
            </Route>

            <Route path={REACT_APP_URL_PREFIX + '/calendar/cabinetSurveys'} exact><AllCabinetSurveysHistory/></Route>
            <Route path={REACT_APP_URL_PREFIX + '/calendar/cabinetSurveys/:orgId/:orgName'}
                   exact><OrganizationCabinetSurveyHistory/></Route>

            <Route path={REACT_APP_URL_PREFIX + '/calendar/carSurveys'} exact><AllCarSurveysHistory/></Route>
            <Route path={REACT_APP_URL_PREFIX + '/calendar/carSurveys/:orgId/:orgName'}
                   exact><OrganizationCarSurveysHistory/></Route>
            <Route path={REACT_APP_URL_PREFIX + '/calendar/carSurveysToday'} exact><AllCarSurveysHistoryToday/></Route>

            <Route path={REACT_APP_URL_PREFIX + '/calendar/:orgId/:orgName'} exact><Calendar/></Route>
            <Route path={REACT_APP_URL_PREFIX + '/calendar/:orgId/:orgName/:medName'} exact><Calendar/></Route>
            <Route path={REACT_APP_URL_PREFIX + '/counterAgents/allOrgList'} exact><AllOrgList/></Route>

            <Route
                path={REACT_APP_URL_PREFIX + '/counterAgents/MedCenterOrgList/:medId/:orgName/:orgId/:history/:historyId'}>
                <OrgPatientList/>
            </Route>

            <Route path={REACT_APP_URL_PREFIX + '/counterAgents/allOrgList/orgHistory/:orgId/:orgName'} exact>
                <OrganizationList/>
            </Route>

            <Route
                path={REACT_APP_URL_PREFIX + '/counterAgents/allOrgList/orgHistory/:orgId/:orgName/history/:historyId/:historyName'}>
                <OrganizationPatientList/>
            </Route>

            <Route path={REACT_APP_URL_PREFIX + '/activities/roles'} exact><Roles/></Route>
            <Route path={REACT_APP_URL_PREFIX + '/activities/analytic/doctor'} exact><PageAnalyticDoctor/></Route>
            <Route path={REACT_APP_URL_PREFIX + '/activities/analytic/places'} exact><PageAnalyticPlaces/></Route>

            <Route path={REACT_APP_URL_PREFIX + '/doctors/diagnoses-mismatch'} exact> <DiagnosesMismatch/></Route>
            <Route path={REACT_APP_URL_PREFIX + '/doctors/list'} exact><Doctors/></Route>

            <Route path={REACT_APP_URL_PREFIX + '/checkIn'} exact>
                <PatientQrResultSwitcher/>
            </Route>
            <Route path={REACT_APP_URL_PREFIX + '/checkBlank/:data'}> <PatientQrResultSwitcher2/> </Route>

            <Redirect to={REACT_APP_URL_PREFIX + '/patients/allPatientList'}/>
        </Switch>
    )
}

export default VerificationCenterRoutes